exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-primary[data-v-3fe3cf28] {\n    width: 70px;\n}\n.btn-primary[data-v-3fe3cf28]:hover {\n    color: #fff !important;\n    background-color: #350f71 !important;\n    border-color: #300e66 !important;\n}\n.btn-outline-primary[data-v-3fe3cf28] {\n    width: 70px;\n}\n", ""]);

// exports
